var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconWtach01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#999",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 2.1a6.9 6.9 0 1 0 0 13.8A6.9 6.9 0 0 0 9 2.1M.9 9a8.1 8.1 0 1 1 16.2 0A8.1 8.1 0 0 1 .9 9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.6 4.65V8.4h3v1.2H8.4V4.65z"
}))));
export default SvgIconWtach01;